var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.555,
    height: 16.945,
    viewBox: "0 0 16.555 16.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.841,0H.712A.711.711,0,0,0,.078.385a.719.719,0,0,0,.056.749l5.543,7.8.006.008a1.579,1.579,0,0,1,.311.938v6.356a.707.707,0,0,0,.708.711.731.731,0,0,0,.279-.056L10.095,15.7a.674.674,0,0,0,.464-.665V9.877a1.58,1.58,0,0,1,.311-.938l.006-.008,5.543-7.8a.718.718,0,0,0,.056-.749A.71.71,0,0,0,15.841,0Zm0,0",
    transform: "translate(0.001 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDark);
export default __webpack_public_path__ + "static/media/filter-dark.6df9940c0080ab6ec4535543fb278b6b.svg";
export { ForwardRef as ReactComponent };